export default __webpack_public_path__ + "static/media/login_logo_bg.e5f51459.svg";